import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**
 * PdfDownloadModal - Modal overlay shown during PDF generation
 * Displays a blocking modal with spinner to prevent user interaction
 * @param {boolean} show - Whether modal is visible
 * @param {string} message - Message to display (default: "Generating PDF... Please wait")
 */
export const PdfDownloadModal = ({ show = false, message = 'Generating PDF... Please wait' }) => {
    return (
        <Modal
            show={show}
            backdrop="static"
            keyboard={false}
            centered
            size="sm"
            data-testid="pdf-download-modal"
        >
            <Modal.Body
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '30px 20px',
                }}
            >
                <Spinner
                    animation="border"
                    role="status"
                    style={{ marginBottom: '15px' }}
                    data-testid="pdf-download-spinner"
                >
                    <span className="sr-only">Loading...</span>
                </Spinner>
                <p
                    style={{
                        fontSize: '14px',
                        color: '#666',
                        marginBottom: 0,
                        textAlign: 'center',
                    }}
                    data-testid="pdf-download-message"
                >
                    {message}
                </p>
            </Modal.Body>
        </Modal>
    );
};

PdfDownloadModal.propTypes = {
    show: PropTypes.bool,
    message: PropTypes.string,
};

export default PdfDownloadModal;
